<template>
  <div>
    <v-text-field
      v-model.number="threshold"
      outlined
      label="% de baisse"
      type="number"
      min="0"
      max="100"
      suffix="%"
      :menu-props="{ zIndex: 13 }"
      @input="validateThreshold"
    >
      <template v-slot:append>
        <HoverTooltip 
          :tooltip-style="{
            backgroundColor: '#333',
            color: '#fff',
            padding: '6px 10px',
            fontSize: '12px',
            borderRadius: '4px',
            whiteSpace: 'nowrap'
          }">
          <v-icon small>mdi-information-outline</v-icon>
          <template v-slot:tooltip>
            Filtrer les données avec une baisse supérieure à ce pourcentage
          </template>
        </HoverTooltip>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  watch,
} from "@vue/composition-api";

import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";
import HoverTooltip from "@/components/common/HoverTooltip.vue";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "ThresholdFilter";

export default {
  name: COMPONENT_NAME,
  components: {
    HoverTooltip
  },
  setup() {
    const { store } = useProxy();
    const { addQueryStringParam, synchronizeFilterWithQueryString } = useQueryString();

    // COMPUTED
    const threshold = computed({
      get: () => store.getters["dataAvailability/getThreshold"],
      set(value) {
        // Ensure value is between 0 and 100
        const validValue = Math.max(0, Math.min(100, value || 30));
        store.dispatch("dataAvailability/updateThreshold", validValue);
      },
    });

    // METHODS
    const validateThreshold = () => {
      // Force validation if input is empty or invalid
      if (threshold.value === null || threshold.value === undefined || threshold.value === '') {
        threshold.value = 30; // Default value
      }
    };

    // WATCH
    watch(threshold, (newValue) => {
      addQueryStringParam({
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: newValue,
        is_integer: true,
      });
    });

    // HOOKS
    onMounted(async () => {
      await synchronizeFilterWithQueryString({
        dispatcher: "dataAvailability/updateThreshold",
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: threshold.value || 30, // Default value is 30
        is_integer: true,
      });
    });

    // DATA
    return {
      threshold,
      validateThreshold,
    };
  },
};
</script>

<style scoped>
/* Ensure consistent styling with other filters */
::v-deep .v-text-field__details {
  padding: 0 12px;
}
</style>